/*
 * @Author: cc
 * @Date: 2019-11-25 12:52:27
 * @LastEditTime : 2020-01-09 17:47:55
 * @LastEditors  : cc
 * @FilePath: \xjmediacloud\app\networkResource\featuredResource\push\push_router.js
 * @Description: 客户端推送路由
 */
'use strict';
angular.module('resCenPushRouterModule', []).config([
    '$stateProvider',
    function($stateProvider) {
        $stateProvider
            .state('front.networksource.featuredresource.push.resource', {
                url: '/resource?typename&nodeid&hid',
                views: {
                    'networksource@front.networksource.featuredresource.push': {
                        templateUrl: './networkResource/featuredResource/push/push_main_tpl.html',
                        controller: 'resCenPushCtrl',
                    },
                },
            })
            .state('front.networksource.featuredresource.push.quickpreview', {
                url: '/quickpreview?typename&nodeid&hid&guid',
                views: {
                    'networksource@front.networksource.featuredresource.push': {
                        templateUrl: './networkResource/featuredResource/push/quickPreview/main_tpl.html',
                        controller: 'pushQuickPreviewCtrl',
                    },
                },
            });
    },
]);
